// J-277 (QB3 items 8 and 8b; Louis, 2026-10-17: "Performance Group before Practice selection and Perf
// group as default", "It opens on Performance group, and the group choice comes before the practice
// choice"): which view Performance (/groups) and Practice (/practice) draw. The group view is the
// default; the URL names the practice view (`view=practices`). Links written before J-277 still open
// what they meant: `view=groups` the group view, and a Practice link that names a TIN with no view (from
// Performance's practice matrix, the Quality report or a bookmark) that practice.

export type ScreenView = "groups" | "practices";

interface ViewSearch {
  view?: ScreenView | undefined;
  tin?: string | undefined;
}

/** The view the URL asks for, before access is applied. */
export function requestedView(search: ViewSearch): ScreenView {
  if (search.view !== undefined) return search.view;
  return search.tin === undefined ? "groups" : "practices";
}

/**
 * The `view` key a URL written by the screen carries: none for the group view (the default), else
 * `practices`. A group view that names a practice (item 8c's Practice field) keeps `view=groups`, since
 * a TIN without a view opens the practice view.
 */
export function viewKey(view: ScreenView, tin?: string): ScreenView | undefined {
  if (view === "practices") return "practices";
  return tin === undefined ? undefined : "groups";
}

/**
 * The search to replace a pre-J-277 Practice link with (`?tin=` and no view): the same, with
 * `view=practices`, so a later change of the header's ACO, which drops the TIN, keeps the practice view.
 * Undefined when the URL already names its view or names no TIN.
 */
export function explicitView<T extends ViewSearch>(search: T): T | undefined {
  if (search.view !== undefined || search.tin === undefined) return undefined;
  return { ...search, view: "practices" };
}

/** The "View by" switch's buttons in their order (item 8): Performance group first. */
export const VIEW_OPTIONS: readonly { view: ScreenView; label: string }[] = [
  { view: "groups", label: "Performance group" },
  { view: "practices", label: "TIN Name" },
];
